import { all, includes, not, values, any, whereEq, equals } from 'ramda';
import { ROLES } from '../../lib/rights';

export const checkUserRole = (userRoles, roles = [], offerId) => {
  const rolesAreValid = all((role) => includes(role)(values(ROLES)));
  if (not(rolesAreValid(roles))) {
    return false;
  }
  
  return roles.some((role) =>
    equals(role, ROLES.admin)
      ? any(whereEq({ role }), userRoles)
      : any(whereEq({ role, offerId }), userRoles));
};
